"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
exports.AvatarRenderer = (0, react_1.memo)(({ avatar, sx, onClick }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: theme.spacing(0.25),
            backgroundColor: theme.palette.background.default,
            borderRadius: "50%",
            width: "fit-content",
            height: "fit-content",
        }, children: (0, jsx_runtime_1.jsx)(material_1.Avatar, { sx: sx, onClick: onClick, src: avatar.url }) }));
});
exports.AvatarRenderer.displayName = "AvatarRenderer";
